module.exports = __webpack_public_path__ + "366e44f15ff99c8d943f824648b60485.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/feature04.png?rte
// module id = 802
// module chunks = 3